const actions = {
  LIST_CLAVE_DESCUENTO: 'LIST_CLAVE_DESCUENTO',
  LIST_CLAVE_DESCUENTO_SELECTBOX: 'LIST_CLAVE_DESCUENTO_SELECTBOX',
  CREATE_CLAVE_DESCUENTO: 'CREATE_CLAVE_DESCUENTO',
  READ_CLAVE_DESCUENTO: 'READ_CLAVE_DESCUENTO',
  UPDATE_CLAVE_DESCUENTO: 'UPDATE_CLAVE_DESCUENTO',
  DELETE_CLAVE_DESCUENTO: 'DELETE_CLAVE_DESCUENTO',


  claveDescuentoList: data => {     
    return {
      type: actions.LIST_CLAVE_DESCUENTO,
      data,
    };
  },

  claveDescuentoListSelectBox: data => {
    return {
      type: actions.LIST_CLAVE_DESCUENTO_SELECTBOX,
      data,
    };
  },

  claveDescuentoCreate: data => {
    return {
      type: actions.CREATE_CLAVE_DESCUENTO,
      data,
    };
  },

  claveDescuentoRead: data => {
    return {
      type: actions.READ_CLAVE_DESCUENTO,
      data,
    };
  },

  claveDescuentoUpdate: data => {
    return {
      type: actions.UPDATE_CLAVE_DESCUENTO,
      data,
    };
  },

  claveDescuentoDelete: () => {
    return {
      type: actions.DELETE_CLAVE_DESCUENTO,      
    };
  },
};

export default actions;
